import {blue} from "@ant-design/colors";
import {MenuOutlined} from "@ant-design/icons";
import {Button, Dropdown, MenuProps} from "antd";
import React, {FC, memo} from "react";
import {SizeType} from "antd/lib/config-provider/SizeContext";
import {SendBlankMail, SendBookingConfirmation, SendInvoice} from "./MenuItems";
import {GetBookingByIdWithCourseLessonBookingsQuery} from "../../../../../generated/graphql";

type SendMailMenuProps = {booking?: GetBookingByIdWithCourseLessonBookingsQuery["bookingByIdWithCourseLessonBookings"]; size?: SizeType};

const SendMailMenu: FC<SendMailMenuProps> = ({booking, size = "small"}) => {
    if (!booking) return null;

    const booker = `${booking?.attendee?.booker?.firstname} ${booking?.attendee?.booker?.lastname} (${booking?.attendee?.booker?.email})`;
    const isReversal = Boolean(booking?.reversalInvoice?.id);
    const thereIsNoInvoice = !booking?.invoice;
    const thereIsNoReversalInvoice = !booking?.reversalInvoice;

    const menu: MenuProps = {
        items: [
            thereIsNoInvoice
                ? null
                : {
                      label: <SendInvoice booking={booking} booker={booker} />,
                      key: 0,
                  },
            thereIsNoReversalInvoice
                ? null
                : {
                      label: <SendInvoice booking={booking} booker={booker} isReversal={isReversal} />,
                      key: 1,
                  },
            {
                label: <SendBookingConfirmation booking={booking} booker={booker} />,
                key: 2,
            },
            {
                label: <SendBlankMail booking={booking} booker={booker} />,
                key: 3,
            },
        ],
    };

    if (!isReversal) menu?.items?.splice(1, 1);

    return (
        <Dropdown menu={{items: menu.items}} trigger={["click"]}>
            <Button size={size} style={{color: blue[5]}}>
                {"Bucher benachrichtigen"}
                <MenuOutlined />
            </Button>
        </Dropdown>
    );
};

export default memo(SendMailMenu);
